// extracted by mini-css-extract-plugin
export var btnClose = "ModalWrapper_btnClose__mCpYG";
export var isLoading = "ModalWrapper_isLoading__xk-Cp";
export var rotate = "ModalWrapper_rotate__T0Yuh";
export var dotty = "ModalWrapper_dotty__Fv5hj";